<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container pb-5">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Shapefile importeren</h1>
        </div>
        <div class="controls">
            <div class="fab small" matTooltip="Terug naar overzicht" matTooltipPosition="below"
                 routerLink="/management">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>

    <form [formGroup]="importForm">
        <div class="row">
            <div class="col-6">
                <ng-select formControlName="customer_area_id" (change)="onCustomerAreaChange()" [items]="customerAreas"
                           bindLabel="name" bindValue="id" placeholder="Selecteer klantgebied">
                </ng-select>
            </div>

            <div class="col-6" *ngIf="importForm.get('customer_area_id')?.value">
                <ng-select formControlName="inspection_id" [items]="inspections" bindLabel="name" bindValue="id"
                           placeholder="Selecteer inspectie" [addTag]="addNewInspection" addTagText="Nieuwe inspectie toevoegen">
                </ng-select>
            </div>
        </div>

        <div *ngIf="importForm.get('customer_area_id')?.value && importForm.get('inspection_id')?.value">
            <input #fileInput type="file" accept=".zip,.shp,.dbf,.prj,.shx" (change)="onFileSelected($event)"
                   [disabled]="features.length > 0" style="display: none;"/>
            <button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="features.length > 0">
                <i class="fas fa-upload"></i> {{selectedFileName || 'Selecteer Shapefile ZIP'}}
            </button>

            <div *ngIf="shapefileCombinations.length > 0" class="combinations-section pt-3">
                <h5>Inhoud shapefile</h5>
                <p>Selecteer de delen uit het shapefile die je wilt importeren:</p>

                <mat-selection-list #shapefileList [multiple]="true" [disabled]="features.length > 0 || !!detection"
                                    (selectionChange)="onSelectionChange($event)" class="combinations-selection-list">

                    <mat-list-option checkboxPosition="before" *ngFor="let combination of shapefileCombinations"
                                     [value]="combination" [selected]="combination.selected" class="combination-option">

                        <div class="combination-content">
                            <div class="combination-header">
                                <span class="combination-name">{{combination.name}}</span>
                                <span class="combination-files">
                                    <span *ngIf="combination.hasShp" class="file-type shp">SHP</span>
                                    <span *ngIf="combination.hasDbf" class="file-type dbf">DBF</span>
                                    <span *ngIf="combination.hasPrj" class="file-type prj">PRJ</span>
                                    <span *ngIf="combination.hasShx" class="file-type shx">SHX</span>
                                </span>
                            </div>
                        </div>

                    </mat-list-option>
                </mat-selection-list>

                <div class="selection-actions">
                    <ng-container *ngIf="features.length < 1">
                        <button mat-button (click)="selectAllCombinations()" [disabled]="!!detection">
                            Selecteer Alles
                        </button>
                        <button mat-button (click)="deselectAllCombinations()" [disabled]="!!detection">
                            Deselecteer Alles
                        </button>
                        <button mat-raised-button color="accent" (click)="processSelectedCombinations()"
                                [disabled]="selectedCombinations.length === 0 || !!detection">
                            Importeer geselecteerde delen ({{selectedCombinations.length}})
                        </button>
                    </ng-container>
                    <button *ngIf="features.length > 0" mat-raised-button color="accent" (click)="openDataDialog()">
                        <i class="fas fa-table"></i>
                        Bekijk data ({{features.length}} features)
                    </button>
                </div>
                <div *ngIf="detection" class="detection-progress">
                    <div class="detection-label">{{detection.label}}</div>
                    <mat-progress-bar mode="determinate" [value]="detection.progress"></mat-progress-bar>
                </div>
            </div>

            <div *ngIf="features.length > 0">
                <h5>Punaisekoppeling</h5>
                <p>Map de waarden uit de shapefile naar het juiste veld in een punaise: </p>
                <div class="form-check mb-3">
                    <mat-checkbox formControlName="autoFillLocationFields">
                        Automatisch locatievelden vullen (straat, postcode, huisnummer, plaats) op basis van GPS-coördinaten
                    </mat-checkbox>
                </div>

                <div formArrayName="pushpinMappings">
                    <div class="mapping" *ngFor="let control of pushpinMappingsFormArray.controls; let i = index">
                        <label>
                            {{pushpinFieldLabels.get(pushpinFields[i])?.name}}
                            <span *ngIf="automaticMappings.has('pushpin-' + i)" class="auto-mapping-badge" title="Automatisch gemapped">
                                <i class="fas fa-magic"></i>
                            </span>
                        </label>
                        <ng-select [formControl]="control" [clearable]="true" appendTo="body"
                                   placeholder="Kies een eigenschap uit de shapefile"
                                   (change)="onMappingManualChange('pushpin', i)">
                            <ng-option *ngFor="let prop of shapefileProperties" [value]="prop">
                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                            </ng-option>
                        </ng-select>
                        <div class="hint">{{pushpinFieldLabels.get(pushpinFields[i])?.description}}</div>
                    </div>
                </div>

                <h5 class="mt-3">Punaisedeel koppeling</h5>
                <p>Map de waarden van een makeringsitem met de waarden uit de shapefile: </p>
                <div formArrayName="pushpinPartMappings">
                    <div class="mapping" *ngFor="let control of pushpinPartMappingsFormArray.controls; let i = index">
                        <label>
                            {{pushpinPartFieldLabels.get(pushpinPartFields[i])?.name}}
                            <span *ngIf="automaticMappings.has('pushpinpart-' + i)" class="auto-mapping-badge" title="Automatisch gemapped">
                                <i class="fas fa-magic"></i>
                            </span>
                        </label>
                        <ng-select [formControl]="control" [clearable]="true" appendTo="body"
                                   placeholder="Kies een eigenschap uit de shapefile"
                                   (change)="onMappingManualChange('pushpinpart', i); onMappingChange(pushpinPartFields[i])">
                            <ng-option *ngFor="let prop of shapefileProperties" [value]="prop">
                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                            </ng-option>
                        </ng-select>
                        <div class="hint">{{pushpinPartFieldLabels.get(pushpinPartFields[i])?.description}}</div>
                    </div>
                </div>

                <!-- Standaard terugvalwaarden sectie -->
                <div *ngIf="availableDefaultFields.length > 0">
                    <h5 class="mt-3">Standaard terugvalwaarden</h5>
                    <p>Stel standaard waarden in voor velden zonder shapefile koppeling:</p>
                    <div *ngFor="let field of availableDefaultFields">
                        <div class="field-mapping" *ngIf="fieldItemsMap.get(field.items)?.length > 0">
                            <label>{{field.label}}</label>
                            <ng-select [formControlName]="field.name" [clearable]="true"
                                       [items]="fieldOptionsMap.get(field.items)" bindLabel="label" bindValue="id"
                                       [virtualScroll]="true"
                                       [placeholder]="'Selecteer ' + field.label.toLowerCase()">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div *ngFor="let field of mappableFields" [ngClass]="field.name + '-mapping-section'">
                    <div *ngIf="fieldMappings.get(field.name)?.size > 0">
                        <h5 class="mt-3">{{field.label}} koppeling</h5>
                        <p>Map de {{field.label.toLowerCase()}} waarden uit de shapefile: </p>
                        <!-- Op key tracken: keyvalue maakt na elke wijziging nieuwe objecten, anders worden alle selects opnieuw opgebouwd -->
                        <div class="field-mapping"
                             *ngFor="let mapping of fieldMappings.get(field.name) | keyvalue; trackBy: trackByKey">
                            <label>{{mapping.key === '' ? '(leeg)' : mapping.key}}</label>
                            <ng-select
                                [clearable]="true"
                                [placeholder]="'Selecteer ' + field.label.toLowerCase()"
                                [items]="fieldOptionsMap.get(field.items)" bindLabel="label" bindValue="id"
                                [virtualScroll]="true"
                                [ngModel]="mapping.value"
                                (ngModelChange)="updateFieldMapping(field.name, mapping.key, $event)"
                                [ngModelOptions]="{standalone: true}">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div *ngIf="importSummary?.alreadyImported > 0 || sameFileImport" class="import-summary import-summary-info mt-4">
                    <h5>Aanvullen</h5>
                    <p *ngIf="sameFileImport">
                        Dit bestand is op {{sameFileImport.created_at | date:'d-M-yyyy HH:mm'}} al geïmporteerd in deze schouwronde.
                        Alleen regels die toen niet zijn geïmporteerd worden nu toegevoegd.
                    </p>
                    <p>
                        {{importSummary.alreadyImported}} regels staan al in deze schouwronde (herkend aan de referentie) en worden niet opnieuw geïmporteerd.
                        <ng-container *ngIf="importSummary.total > 0">De overige {{importSummary.total}} regels worden toegevoegd; delen die binnen 1,5 meter van een bestaande punaise liggen komen onder die punaise.</ng-container>
                    </p>
                </div>
                <div *ngIf="importSummary?.referencesEmpty > 0 || importSummary?.referencesDuplicate > 0" class="import-summary mt-4">
                    <h5>Referentie deel niet uniek</h5>
                    <p>
                        Elk deel hoort een unieke referentie te krijgen.
                        <ng-container *ngIf="importSummary.referencesEmpty > 0">{{importSummary.referencesEmpty}} regels hebben geen referentie. </ng-container>
                        <ng-container *ngIf="importSummary.referencesDuplicate > 0">{{importSummary.referencesDuplicate}} regels delen hun referentie met een andere regel. </ng-container>
                        Controleer of de juiste kolom gekoppeld is.
                    </p>
                </div>
                <div *ngIf="importSummary?.skipped > 0" class="import-summary mt-4">
                    <h5>Overgeslagen regels</h5>
                    <p>
                        {{importSummary.skipped}} van de {{importSummary.total}} regels worden niet geïmporteerd.
                        Vul de koppelingen hierboven aan om ze alsnog mee te nemen.
                    </p>
                    <div *ngFor="let group of importSummary.groups" class="import-summary-group">
                        <b>{{group.label}} ontbreekt</b> ({{group.count}} regels):
                        <ng-container *ngFor="let missing of (expandedSummaryGroups.has(group.label) ? group.values : (group.values | slice:0:importSummaryMaxValues)); let last = last">
                            {{missing.value}} ({{missing.count}}){{last ? '' : ', '}}
                        </ng-container>
                        <button *ngIf="group.values.length > importSummaryMaxValues" (click)="toggleSummaryGroup(group.label)"
                                class="import-summary-toggle" type="button">
                            {{expandedSummaryGroups.has(group.label) ? 'minder tonen' : 'en nog ' + (group.values.length - importSummaryMaxValues) + ' andere waarden'}}
                        </button>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button mat-raised-button color="primary" type="submit" (click)="import()"
                            [disabled]="importing !== null || importForm.invalid">
                        <span *ngIf="importing === null">Importeren</span>
                        <span *ngIf="importing !== null">Bezig met importeren... ({{importing}}/{{totalPushpins}})</span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
